import { FC } from "react"
import { Paper as MuiPaper, PaperProps, styled } from "@mui/material"

export const Paper: FC<PaperProps> = styled(MuiPaper)(() => ({
    padding: "12px",
    borderRadius: 0,
    color: "unset",
    overflow: "unset",
}))
